import { IContentsContentElem } from 'app-template-lib/utils';
import { TContentsContentParams } from '../../../../shared/t-contents-params';
import ColumnLayout from '../../../../main/components/column-layout';

import { Top } from './toppage.presenter';
import { useToppageContainer } from './toppage.container.hooks';
import { useQuery } from '@apollo/client';
import { FETCH_M_LG_CONFIG } from '@/main/queries/setting_m_lg_config.queries.type';
import setting_m_lg_configQueries from '@/main/queries/setting_m_lg_config.queries';
import { useParams } from 'react-router-dom';

/**
 * TOPページコンテナコンポーネント
 * @param param0
 * @returns
 */

export function TopPage({ formID, params }: IContentsContentElem<TContentsContentParams>) {
    // HACK: ↓データの取得はフック内で無くこのコンテナーで行うこと。CrossTownのReadme.md Component 実装（Container/Presentational Pattern）例 を参照
    // TOPページのContainerカスタムフック
    const { data, sainyus, saishutsus } = useToppageContainer();
    // HACK: ↓コンテナー以外でuseParamsから取得しないこと。関数の引数で渡してください。CrossTownのReadme.md Component 実装（Container/Presentational Pattern）例 を参照
    const { lgcode, jigyoYear }: { lgcode: string; jigyoYear: string } = useParams();

    // LG設定データ取得
    const { data: lgConfigResult } = useQuery<FETCH_M_LG_CONFIG>(setting_m_lg_configQueries.FETCH_M_LG_CONFIG, {
        variables: { lgcode },
        fetchPolicy: 'cache-first',
    });

    const lgConfigData = lgConfigResult?.setting_m_lg_config[0];

    return (
        <ColumnLayout>
            <Top formID={formID} params={params} data={data} sainyus={sainyus} saishutsus={saishutsus} lgconfig={lgConfigData} />
        </ColumnLayout>
    );
}
